import React, { useEffect, useState } from "react";
import { useUsuario } from "../../../../context/usuarioContext";
import Container from "../../../../components/Container/Container";
import { Button, Pagination } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./listaContratos.scss";
import BotonAtomico from "../../../../components/PartesAtomicas/BotonAtomico";

const ListaContratos = () => {
  const ColorButton = styled(Button)(() => ({
    color: "#FFFF",
    borderRadius: 100,
    backgroundColor: "#F77500",
    "&:hover": {
      backgroundColor: "#fa8b23",
    },
  }));

  const { contratoSeleccionado, contratos, setContratoSeleccionado } =
    useUsuario();
  const [paginas, setPaginas] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const elementosPorPagina = 3;
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [listaContratos, setListaContratos] = useState([]);

  useEffect(() => {
    if (contratos) {
      const filterMovil = contratos.filter(
        (item) => item.unidad_negocio != contratoSeleccionado.unidad_negocio
      );

      for (let i = 0; i < filterMovil.length; i += elementosPorPagina) {
        const pagina = filterMovil.slice(i, i + elementosPorPagina);
        setPaginas(...paginas, pagina);
      }
      setListaContratos(filterMovil);
      setTotalPaginas(Math.ceil(filterMovil.length / elementosPorPagina));
    }
  }, [contratoSeleccionado]);

  const handleChangePagina = (event, nuevaPagina) => {
    setPaginaActual(nuevaPagina);
  };

  return (
    <>
      {listaContratos.length > 0 ? (
        <>
          {listaContratos
            .slice(
              (paginaActual - 1) * elementosPorPagina,
              paginaActual * elementosPorPagina
            )
            .map((item) => {
              return (
                <Container
                  key={item.id_contrato}
                  label={`Contrato ${
                    item.unidad_negocio == 1 ? "móvil" : "hogar"
                  } ${item.codigo ?? null}`}
                >
                  <div
                    className="contratos__elementos"
                    // style={{
                    //   justifyContent: "space-between",
                    //   display: "flex",
                    //   flexWrap: "wrap",
                    //   alignItems: "center",
                    //   // marginLeft: "5rem",
                    //   // marginRight: "5rem",
                    //   marginBottom: "2rem",
                    // }}
                  >
                    <p
                      // style={{ color: "#00657D", fontWeight: 600, margin: 'auto' }}
                      className="contratos__elementos__p"
                    >
                      {item.unidad_negocio == 1 ? item.linea : item.plan.nombre}
                    </p>
                    <ColorButton
                      variant="contained"
                      onClick={() => setContratoSeleccionado(item)}
                      style={{ margin: "auto" }}
                      className="contratos__elementos__ColorButton"
                    >
                      Ver contrato
                    </ColorButton>
                  </div>
                </Container>
              );
            })}
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Pagination
              sx={{ marginTop: "2rem" }}
              count={totalPaginas}
              page={paginaActual}
              onChange={handleChangePagina}
            />
          </div>
        </>
      ) : (
        <Container>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <p style={{ color: "#00657D" }}>
              {contratoSeleccionado.unidad_negocio == 1 || contratoSeleccionado.plan.nombre == "Fijo"
                ? "No posees servicio Hogar"
                : "No posees servicio Móvil"}
            </p>
          </div>

          <div style={{ justifyContent: "center", display: "flex" }}>
            <BotonAtomico
              tipo="button"
              label="contratar"
              colorCorp={0}
              onClick={()  =>
                !contratoSeleccionado.unidad_negocio == 1
                  ? window.open(
                      "https://www.tumundo.cl/movil/plan-portabilidad/individual/",
                      "_blank"
                    )
                  : window.open(
                      "https://www.tumundo.cl/hogar/1-mundo/?tab=tvhd",
                      "_blank"
                    )}
            />
          </div>
        </Container>
      )}
    </>
  );
};

export default ListaContratos;
